import { HttpTimeoutError } from '../types/http-timeout-error';
export const withTimeout = async (fn, timeoutMs) => {
    const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new HttpTimeoutError()), timeoutMs);
    });
    return Promise.race([fn(), timeoutPromise]);
};
//# sourceMappingURL=with-timeout.js.map